import type { RHFGroupFieldValue } from '@/components/dynamic-filter/FilterFormGroup';
import type { DeviceGroupResponse } from '@/types/apps/device-group.type';
import type { GqlListResponse } from '@/types/common/api.type';
import { BaseService } from '@/types/service/graphql-service.type';

export interface DeviceGroupServiceInterface {}

type DeviceGroupGraphQLListResponse = GqlListResponse<DeviceGroupResponse>;

export class DeviceGroupGraphQLService
    extends BaseService
    implements DeviceGroupServiceInterface
{
    public getEntityName(): string {
        return 'deviceGroup';
    }

    public getFields(): Record<string, any> {
        return {
            code: true,
            createdBy: true,
            createdDate: true,
            deletedAt: true,
            deletedBy: true,
            description: true,
            deviceTypeCode: true,
            deviceTypeId: true,
            id: true,
            isDeleted: true,
            modifiedBy: true,
            modifiedDate: true,
            name: true,
            deviceType: {
                devices: {
                    address: true,
                    createdBy: true,
                    createdDate: true,
                    customerId: true,
                    deviceGroupId: true,
                    deviceModelId: true,
                    deviceSKUId: true,
                    deviceStatus: true,
                    deviceTypeId: true,
                    id: true,
                    installationDate: true,
                    name: true,
                    note: true,
                    operationTime: true,
                    overload: true,
                    pressure: true,
                    processingSpeed: true,
                    rfid: true,
                    rotationSpeed: true,
                    serialNumber: true,
                    softWareVersion: true,
                    supplier: true,
                    temperature: true,
                    timeUnit: true,
                    totalHandledItems: true,
                    usageTypeId: true,
                    warrantyDay: true,
                    warrantyPeriod: true,
                },
                code: true,
                name: true,
            },
        };
    }

    public async index(query: string): Promise<DeviceGroupGraphQLListResponse> {
        return this.fetchGqlList<DeviceGroupGraphQLListResponse>(
            query,
            this.getEntityName()
        );
    }

    public getFilterByRole(): Record<string, RHFGroupFieldValue> {
        if (!this.getQueryById() || !this.getRoleTypeManager().getQuery) {
            return {};
        }

        return this.getRoleTypeManager().getQuery('deviceGroup', {
            userId: this.getQueryById(),
        });
    }
}
